export const SELECTOR = Object.freeze({
    APP: "app",
    MAIN: "main",
    HEADER: "header",
    NAV: "nav"
})